export const YEARLY_FOCUS_MODES = [
    {
        id: 'yearly-milestones',
        spread_slug: 'annual-wheel',
        label: 'Yearly Milestones',
        description: 'Raggruppa il ciclo annuale in passaggi e milestone più nette.',
        highlighted_positions: [1, 4, 7, 10, 13],
        narrative_bias: 'forecast',
    },
    {
        id: 'yearly-thresholds',
        spread_slug: 'annual-wheel',
        label: 'Yearly Thresholds',
        description: 'Mette in luce le soglie di cambio fase lungo l’anno simbolico.',
        highlighted_positions: [1, 3, 6, 9, 12],
        hidden_positions: [2, 5, 8, 11],
        narrative_bias: 'clarity',
    },
];
//# sourceMappingURL=yearly-focus.js.map